import React from "react";

import EventShowMore from "./EventShowMore/EventShowMore";

import {Wrapper} from "./ShowMore.style";

import {ReactComponent as CloseIcon} from '../../../../assets/icons/close.svg'


const ShowMore = ({opened, close, events, date, setHovered}) => {

    return (
        <Wrapper opened={opened}>
            <CloseIcon className='close' onClick={close}/>
            <div className="date">{date.format('MMMM DD, YYYY')}</div>
            {events.map(event =>
                <EventShowMore event={event} setHovered={setHovered}>


                </EventShowMore>
            )}

        </Wrapper>
    )
}

export default ShowMore